import React from "react";
import brand from "../db/brand";

const Outcomes = () => (
  <section className="outcomes">
    <div className="shell">
      <div className="row">
        {brand.outcomes.map((m) => (
          <div key={m.label} className="cell">
            <div className="big">{m.big}</div>
            <div className="label">{m.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Outcomes;
